export enum Types {
  SET_IS_LOADING = 'REPOSITORY/SET_IS_LOADING',
  SET_REPOSITORIES = 'REPOSITORY/SET_REPOSITORIES',
  SET_PAGE_SIZE = 'REPOSITORY/SET_PAGE_SIZE',
  SET_CURSOR = 'REPOSITORY/SET_CURSOR',
  SET_HAS_NEXT_PAGE = 'REPOSITORY/SET_HAS_NEXT_PAGE',
}
